export default __webpack_public_path__ + "static/41aa-2901ae4b117be790f2d833713e0dcf64.png";